<template>
  <Swiper
    :autoplay="{
      delay: 5000,
      disableOnInteraction: false,
      waitForTransition: true
    }"
    :space-between="30"
    :centered-slides="true"
    :pagination="{
      clickable: true
    }"
    :effect="'fade'"
    :rewind="true"
    :modules="modules"
    @slide-change="onSlideChange"
  >
    <SwiperSlide v-for="(data, idx) in swiperData" :key="data.id">
      <section class="slide-bg-wrapper flex w-screen justify-center">
        <!-- 배경 이미지 -->
        <div class="slide-bg-container">
          <OptimizedImage
            base-path="image/home/swiper"
            :file-name="`img_slide0${idx + 1}`"
            alt="bg slider image"
            img-format="jpg"
            :localized="data.hasEnglishVersion"
            is-mobile
            image-class="slide-bg-image animate-slide"
          />
        </div>
        <!-- 콘텐츠 영역 -->
        <div class="z-10 flex h-[580px] w-full px-6 sm:px-16 lg:h-[860px] lg:w-[80vw] lg:px-0">
          <div class="z-50 pt-12 lg:pt-32">
            <img
              src="assets/svg/logo_kvc_x_guardiann.svg"
              :class="['mb-2.5 h-[17px] lg:mb-6 lg:h-10', {invisible: idx != 1}]"
              alt="logo_kvc"
            />
            <h1
              :class="[
                'pb-4 text-2xl font-bold leading-relaxed lg:pb-5 lg:text-[40px] lg:font-extrabold lg:leading-[55px]',
                idx == 0 ? 'text-slate-700' : 'text-white'
              ]"
            >
              {{ $t(data.title) }}
            </h1>
            <span
              :class="[
                'gn-text-xl block pb-9 font-bold lg:pb-12 lg:leading-relaxed',
                idx == 0 ? 'text-slate-700' : 'text-white'
              ]"
            >
              {{ $t(data.context) }}
            </span>

            <div v-if="idx == 0" class="flex w-full flex-wrap gap-2.5 lg:w-96 lg:flex-nowrap">
              <SocialButton page="home" />
            </div>
            <button
              v-else
              class="rounded-full bg-white px-6 py-3 lg:h-[62px] lg:px-8"
              @click="navigateTo(localeRoute(data.buttonLink))"
            >
              <span class="gn-text-xl font-bold"> {{ $t(data.buttonText) }} </span>
            </button>

            <img
              src="assets/svg/ani_icon_scroll.svg"
              class="absolute bottom-36 hidden animate-bounce lg:block"
              alt="ani_icon_scroll"
            />
          </div>
        </div>
      </section>
    </SwiperSlide>
  </Swiper>
</template>

<script setup>
import {Swiper, SwiperSlide} from 'swiper/vue'
import {Autoplay, Pagination, EffectFade} from 'swiper/modules'
import SocialButton from '~/components/common/SocialButton.vue'
import OptimizedImage from '~/components/common/OptimizedImage.vue'

const localeRoute = useLocaleRoute()
const modules = [Autoplay, Pagination, EffectFade]

/** 슬라이드 변경 이벤트 핸들러 */
const onSlideChange = swiper => {
  const activeSlide = swiper.slides[swiper.activeIndex]
  if (activeSlide) {
    const image = activeSlide.querySelector('.slide-bg-image')
    if (image) {
      image.classList.remove('animate-slide')
      void image.offsetWidth // 강제 리플로우로 애니메이션 재시작
      image.classList.add('animate-slide')
    }
  }
}

const swiperData = [
  {
    id: 0,
    title: 'main.swiper1.title',
    context: 'main.swiper1.context',
    hasEnglishVersion: true
  },
  {
    id: 1,
    title: 'main.swiper2.title',
    context: 'main.swiper2.context',
    buttonText: 'main.swiper2.buttonText',
    buttonLink: '/introduction/guardiann',
    hasEnglishVersion: false
  },
  {
    id: 2,
    title: 'main.swiper3.title',
    context: 'main.swiper3.context',
    buttonText: 'main.swiper3.buttonText',
    buttonLink: '/introduction/perq',
    hasEnglishVersion: true
  },
  {
    id: 3,
    title: 'main.swiper4.title',
    context: 'main.swiper4.context',
    buttonText: 'main.swiper4.buttonText',
    buttonLink: '/introduction/drRodin',
    hasEnglishVersion: false
  }
]
</script>
